import React, { useState } from 'react';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Confirm from '../common/Confirm';
import { deleteAgent } from '../../api/agent';

export default function AgentPersistenceControls({
  onAgentDeleted,
  agentDefinitionId,
  sx,
  setError,
  setInform,
}) {
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);

  const handleDeleteConfirm = async () => {
    if (!agentDefinitionId) return;
    try {
      await deleteAgent({ id: agentDefinitionId });
      onAgentDeleted?.();
      setInform?.({ success: 'Agent deleted.' });
    } catch (err) {
      setError?.(`Delete failed: ${err?.response?.data?.message || err?.message || err}`);
    }
  };

  return (
    <>
      <Box sx={{ ...sx, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        <Button
          variant="outlined"
          color="danger"
          startDecorator={<DeleteOutlineIcon />}
          disabled={!agentDefinitionId}
          onClick={() => setDeleteConfirmOpen(true)}
          sx={{ flex: 1, minWidth: 0 }}
        >
          Delete agent
        </Button>
      </Box>
      <Confirm
        open={deleteConfirmOpen}
        setOpen={setDeleteConfirmOpen}
        onConfirm={handleDeleteConfirm}
        title="Delete agent?"
      >
        This will permanently delete this agent definition. You can still save the current form as a new agent first.
      </Confirm>
    </>
  );
}
